// extracted by mini-css-extract-plugin
export default {"banner":"MainPage_banner__APhpL","page":"MainPage_page__7pQyU","images":"MainPage_images__PeOKT","image":"MainPage_image__tCGQk"};